import { MouseOutlined, RemoveRedEyeOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import { Card } from '~/shared';

interface QueueStatusCardsProps {
  impressions: number;
  clicks: number;
  // impressionsStatus: 'CRITICO' | 'ATENCAO' | 'NORMAL';
  // clicksStatus: 'CRITICO' | 'ATENCAO' | 'NORMAL';
}

export const QueueStatusCards = ({
  impressions,
  clicks,
  // impressionsStatus,
  // clicksStatus,
}: QueueStatusCardsProps) => {
  return (
    <Box>
      <Box
        sx={{
          width: '95%',
          maxWidth: theme => theme.breakpoints.values.xl + 300,
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 3,
        }}
      >
        <Card
          title="Impressões"
          iconBackgroundColor="#F5F5F5"
          iconColor="#757575"
          icon={<RemoveRedEyeOutlined />}
          value={impressions.toLocaleString('pt-BR')}
          sx={{
            position: 'relative',
            flex: 1,
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '4px',
              backgroundColor: '#9E9E9E',
            },
          }}
        />

        <Card
          title="Cliques"
          iconBackgroundColor="#F5F5F5"
          iconColor="#757575"
          icon={<MouseOutlined />}
          value={clicks.toLocaleString('pt-BR')}
          sx={{
            position: 'relative',
            flex: 1,
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '4px',
              backgroundColor: '#9E9E9E',
            },
          }}
        />
      </Box>
    </Box>
  );
};
